<template>
  <div class="box">
    <div class="orioc-container" >
      <div class="title">
        <p class="title-content">政策 / 广告 / 资讯 / 招聘</p>
        <div  class="title-nav" ></div>
      </div>
      <div class="card-container">
          <div class="card article-card orioc-shadow">
            <div class="card-body">
              <div class="notice-title notice-flex">
                <h6>政策法规</h6>
                <span style="font-size: 14px;">更多</span>
              </div>
              <div class="notice-content notice-flex">
                <p class="notice-content-title"> 安徽省电梯需维保和检验改革试点工…</p>
                <span class="notice-time notice-flex"> 2019/12/12 21:34:59</span>

              </div><div class="notice-content notice-flex">
                <p class="notice-content-title"> 安徽省电梯需维保和检验改革试点工…</p>
                <span class="notice-time notice-flex"> 2019/12/12 21:34:59</span>

              </div><div class="notice-content notice-flex">
                <p class="notice-content-title"> 安徽省电梯需维保和检验改革试点工…</p>
                <span class="notice-time notice-flex"> 2019/12/12 21:34:59</span>

              </div><div class="notice-content notice-flex">
                <p class="notice-content-title"> 安徽省电梯需维保和检验改革试点工…</p>
                <span class="notice-time notice-flex"> 2019/12/12 21:34:59</span>

              </div><div class="notice-content notice-flex">
                <p class="notice-content-title"> 安徽省电梯需维保和检验改革试点工…</p>
                <span class="notice-time notice-flex"> 2019/12/12 21:34:59</span>
              </div>

            </div>
          </div>


        <div class="card article-card orioc-shadow" >
          <div class="card-body">
            <div class="notice-title notice-flex">
              <h6>政策法规</h6>
              <span style="font-size: 14px;">更多</span>
            </div>
            <div class="notice-content notice-flex">
              <p class="notice-content-title"> 安徽省电梯需维保和检验改革试点工…</p>
              <span class="notice-time notice-flex"> 2019/12/12 21:34:59</span>

            </div><div class="notice-content notice-flex">
            <p class="notice-content-title"> 安徽省电梯需维保和检验改革试点工…</p>
            <span class="notice-time notice-flex"> 2019/12/12 21:34:59</span>

          </div><div class="notice-content notice-flex">
            <p class="notice-content-title"> 安徽省电梯需维保和检验改革试点工…</p>
            <span class="notice-time notice-flex"> 2019/12/12 21:34:59</span>

          </div><div class="notice-content notice-flex">
            <p class="notice-content-title"> 安徽省电梯需维保和检验改革试点工…</p>
            <span class="notice-time notice-flex"> 2019/12/12 21:34:59</span>

          </div><div class="notice-content notice-flex">
            <p class="notice-content-title"> 安徽省电梯需维保和检验改革试点工…</p>
            <span class="notice-time notice-flex"> 2019/12/12 21:34:59</span>

          </div>



          </div>


        </div>




      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: "index",
    data(){
      return{
      }
    }
  }
</script>


<style lang="scss" scoped>
  .box{
    padding-top: 30px;
    padding-bottom: 20px;
    background:  #f9f9f9;
  }
  .title{
    text-align: center;
    margin-bottom: 50px;

  }
  .title-content{
    font-size: 20px;
    padding: 10px 5px 0;
    font-weight: 500;

  }
  .title-nav{
    width: 30px;
    height: 3px;
    background: #1B91FF;
    border-radius: 150px;
    margin: 20px auto;
  }
  .notice-flex{
    display: flex;
    justify-content: space-between;
  }

  .card-container{
    display: flex;
    justify-content: space-between;

    .card{
      flex: 0 0 45%;
      padding:10px 20px;
      border-radius: 4px;
      background: white;
    }
  }
  .notice-title{
    padding: 20px 0;
  }
  .notice-content{
    padding: 20px 0;
    border-top: 1px solid #EBEEF5;
    .notice-content-title{
      font-size: 14px;
    }

  }
  .notice-time{
    font-size: 13px;
    color: #BFBFBF;
  }


</style>



// WEBPACK FOOTER //
// src/components/Notice/index.vue